export default __webpack_public_path__ + "static/media/night.6a6a8549.jpg";